<template>
  <div class="mt-5">
    <component
      :is="getControlComponent"
      :vars="getVars"
      :actors="actors"
      :defaultValue="getDefaultValue"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/service-groups/controls/Button.vue';
import Slider from '@/components/service-groups/controls/Slider.vue';

export default {
  name: 'ArgumentControl',
  props: {
    actors: {
      type: Array,
      required: true,
    },
    argument: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      controls: {
        number: Slider,
        boolean: Button,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getVarsForActors',
    ]),
    getVars() {
      return this.getVarsForActors(this.actors);
    },
    getVar() {
      return this.getVars[0];
    },
    getControlComponent() {
      return this.controls[typeof this.getVar.value];
    },
    getDefaultValue() {
      if (this.getControlComponent === Slider) {
        return Math.round(
          this.getVars.reduce((sum, currVar) => sum + currVar.value, 0) / this.getVars.length,
        );
      }
      return undefined;
    },
  },
};
</script>

<style scoped>

</style>
